import getEnv from "./getEnv";

function envOr(name: string, fallback: string): string {
  const v = getEnv(name);
  if (v == null || String(v).trim() == "") {
    return fallback;
  }
  return String(v);
}

export function getThemeColor(): "blue" | "emerald" {
  const raw = getEnv("VUE_APP_THEME_COLOR");
  const v = raw ? String(raw).trim().toLowerCase() : "";
  if (v == "emerald") {
    return "emerald";
  }
  return "blue";
}

export const branding = {
  brandName: envOr("VUE_APP_BRAND_NAME", "Moinho Globo"),
  pageTitle: envOr("VUE_APP_PAGE_TITLE", "Moinho Globo Agendamentos"),
};
